import { FC } from 'react';

interface IconProps {
  className?: string;
}

const FaceMask: FC<IconProps> = ({ className }) => (
  <svg
    viewBox="0 0 338 482"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M169 2C224.36 2 266.019 24.0418 293.888 59.8662C321.804 95.7516 336 145.628 336 201.396C336 257.151 319.704 326.985 290.541 382.831C261.316 438.795 219.579 480 169 480C118.421 480 76.6839 438.795 47.459 382.831C18.2957 326.985 2.00008 257.151 2 201.396C2 145.628 16.1962 95.7516 44.1123 59.8662C71.981 24.0418 113.64 2 169 2Z"
      stroke="#81EFBD"
      strokeWidth="4"
    />
  </svg>
);

export default FaceMask;
